import axios from "axios";

const store = {
    state: {
        good_size: []
    },
    mutations: {
        INITIALIZE_GOODSIZE(state, payload) {
            state.good_size = payload;
        }
    },
    actions: {
        initializeGoodSize({ commit, state }) {
            return axios
                .get(this._vm.$endpoints.customer_good_size)
                .then(res => {
                    let response = res.data.data;
                    commit("INITIALIZE_GOODSIZE", response);
                })
                .catch(err => {
                    console.log(err);
                });
        }
    }
};

export default store;
